import { AppFeatureVesselBM } from 'src/types/BusinessModel/AppFeature/AppFeatureVesselBM';
import { AppFeatureBM } from '../types/BusinessModel/AppFeature/AppFeatureBM';
import { AppFeature } from '../types/ViewModel/AppFeature/AppFeature';
import { getDateFromFormat } from 'odfjell-date-time-utils/dateTimeUtils';
import { AppFeatureVessel } from 'src/types/ViewModel/AppFeature/AppFeatureVessel';

export const mapAppFeatureVessel = (appFeatureVessel: AppFeatureVesselBM): AppFeatureVessel => {
    return {
        imoNumber: appFeatureVessel.imoNumber,
        fromDate: appFeatureVessel.fromDate ? getDateFromFormat(appFeatureVessel.fromDate, "yyyy-MM-dd'T'HH:mm:ss") : null,
    };
};

export const mapAppFeatureVesselList = (appFeatureVessels: AppFeatureVesselBM[]): AppFeatureVessel[] =>
    appFeatureVessels.map((appFeatureVessel) => mapAppFeatureVessel(appFeatureVessel));

export const createAppFeature = (appFeature: AppFeatureBM): AppFeature => {
    return {
        appFeatureId: appFeature.appFeatureId,
        appId: appFeature.appId,
        featureName: appFeature.featureName,
        fromDate: appFeature.fromDate ? getDateFromFormat(appFeature.fromDate, "yyyy-MM-dd'T'HH:mm:ss") : null,
        toDate: appFeature.toDate ? getDateFromFormat(appFeature.toDate, "yyyy-MM-dd'T'HH:mm:ss") : null,
        roles: appFeature.roles,
        imoNumbers: appFeature.appFeatureVessels.map((v) => v.imoNumber),
        vessels: mapAppFeatureVesselList(appFeature.appFeatureVessels),
        isForcedEnabled: false,
        isForcedDisabled: false,
        disableWhenOffline: appFeature.disableWhenOffline,
    };
};

export const createAppFeatureList = (appFeatures: AppFeatureBM[]) => appFeatures.map((appFeature) => createAppFeature(appFeature));
